import React, { useContext, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import picture from "../assets/profile.png";
import { default as AppContext, default as Context } from "./GlobalContext";
import { Container } from "./MovieList";

const UserSkeleton = () => {
  return <div className="w-12 h-12 rounded-full skeleton"></div>;
};

const Profile = ({ onClick }) => {
  const { user } = useContext(AppContext);

  return (
    <div
      className="flex w-12 h-12 bg-gray-100 rounded-full cursor-pointer"
      onClick={() => onClick()}
    >
      {/*  <Link to="/profile"> */}
      <img src={picture} alt={user.username} />
      {/*  </Link> */}
    </div>
  );
};
const Button = () => {
  const [open, setOpen] = useState(false);
  const { firebase } = useContext(AppContext);

  return (
    <React.Fragment>
      <div className="relative z-50 inline-block text-left">
        <Profile onClick={() => setOpen((prev) => !prev)} />
        <div
          className={
            open
              ? "origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg "
              : "origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg hidden"
          }
        >
          <div className="bg-white rounded-md shadow-xs">
            <Link
              to={`/profile`}
              className="block px-4 py-3 text-sm leading-5 text-gray-700 rounded-md hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
            >
              Profile
            </Link>
            <div
              className="py-1 cursor-pointer"
              onClick={() => firebase.logout()}
            >
              <div className="block px-4 py-3 text-sm leading-5 text-gray-700 border-t-2 border-gray-100 rounded-md hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900">
                Logout
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default function Navbar() {
  // const { setModalOpen, user, authLoading } = useContext(AppContext);
  return (
    <Context.Consumer>
      {(globalState) => (
        <nav className="flex items-center justify-between h-24 text-white bg-gray-900">
          <Container>
            <div className="flex items-center justify-center w-full">
              <NavLink to="/" className="text-2xl font-bold uppercase">
                Movie Storm
              </NavLink>
              {/* <div className="right__content">
                <a
                  href="https://github.com/abhagsain/rmdb"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-gray-400"
                >
                  Github
                </a>
              authLoading ? (
                  <UserSkeleton />
                ) : !user ? (
                  <button
                    className="px-6 py-2 uppercase rounded bg-accent"
                    onClick={() => setModalOpen(true)}
                  >
                    Login/Register
                  </button>
                ) : (
                  <Button />
                ) 
              </div> */}
            </div>
          </Container>
        </nav>
      )}
    </Context.Consumer>
  );
}
